var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArb = function SvgArb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arb_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#213147",
    d: "M1.884 4.138v4.136c0 .266.14.506.372.641l3.582 2.068c.228.13.511.13.739 0l3.583-2.068a.741.741 0 0 0 .371-.641V4.138a.737.737 0 0 0-.371-.641L6.577 1.429a.744.744 0 0 0-.739 0L2.256 3.497a.737.737 0 0 0-.368.641h-.004Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#12AAFF",
    d: "m6.986 7.008-.51 1.401a.202.202 0 0 0 0 .122l.877 2.41 1.017-.587-1.22-3.346a.088.088 0 0 0-.164 0ZM8.012 4.653a.088.088 0 0 0-.165 0l-.51 1.401a.202.202 0 0 0 0 .123l1.439 3.946 1.017-.587-1.781-4.878v-.005Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9DCCED",
    d: "M6.205 1.585c.026 0 .05.009.072.021l3.874 2.237a.143.143 0 0 1 .072.127v4.473c0 .05-.03.101-.072.126l-3.874 2.237a.142.142 0 0 1-.072.021.142.142 0 0 1-.072-.02L2.26 8.568a.143.143 0 0 1-.071-.126V3.965c0-.05.03-.1.071-.126l3.874-2.237a.142.142 0 0 1 .072-.021v.004Zm0-.654a.803.803 0 0 0-.4.106L1.93 3.273a.796.796 0 0 0-.4.692V8.44c0 .287.151.548.4.692l3.874 2.236a.792.792 0 0 0 .401.106c.14 0 .275-.034.401-.106l3.874-2.236a.796.796 0 0 0 .401-.692V3.965a.796.796 0 0 0-.4-.692L6.6 1.037a.791.791 0 0 0-.4-.106h.004Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213147",
    d: "m3.64 10.127.358-.98.718.596-.671.616-.405-.232Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.876 3.649h-.983a.178.178 0 0 0-.165.113L2.623 9.535l1.017.587 2.32-6.36a.087.087 0 0 0-.08-.118l-.004.005ZM7.598 3.649h-.983a.178.178 0 0 0-.165.114l-2.405 6.591 1.017.587 2.616-7.178a.087.087 0 0 0-.08-.119v.005Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arb_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.93.931h10.55v10.55H.93z"
  })))));
};
export default SvgArb;